import { render, staticRenderFns } from "./post-basics.vue?vue&type=template&id=9711862a&scoped=true"
import script from "./post-basics.vue?vue&type=script&lang=js"
export * from "./post-basics.vue?vue&type=script&lang=js"
import style0 from "./post-basics.vue?vue&type=style&index=0&id=9711862a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9711862a",
  null
  
)

export default component.exports